import { createAction } from '../../utils/redux/createAction';

const actionsScope = 'appointment/payment-info-modal';

export const APPOINTMENT_PAYMENT_INFO_MODAL = {
  OPEN: `${actionsScope}/open`,
  CLOSE: `${actionsScope}/close`,
  UPDATE_PAYMENT_ORDER_ID: `${actionsScope}/update-payment-order-id`,
};

export const appointmentPaymentInfoModalActions = {
  open: createAction(APPOINTMENT_PAYMENT_INFO_MODAL.OPEN),
  close: createAction(APPOINTMENT_PAYMENT_INFO_MODAL.CLOSE),
  updatePaymentOrderId: createAction(
    APPOINTMENT_PAYMENT_INFO_MODAL.UPDATE_PAYMENT_ORDER_ID,
  ),
};

const initialState = {
  opened: false,
  props: {},
};

// used for account_form payment method
export default (state = initialState, { type, payload }) => {
  switch (type) {
    case APPOINTMENT_PAYMENT_INFO_MODAL.OPEN: {
      return {
        ...state,
        opened: true,
        props: payload,
      };
    }

    case APPOINTMENT_PAYMENT_INFO_MODAL.CLOSE: {
      return {
        ...initialState,
      };
    }

    case APPOINTMENT_PAYMENT_INFO_MODAL.UPDATE_PAYMENT_ORDER_ID: {
      return {
        ...state,
        props: {
          ...state.props,
          paymentOrderId: payload,
        },
      };
    }

    default: {
      return state;
    }
  }
};



// WEBPACK FOOTER //
// ./src/redux/appointmentForm/appointment-payment-info-modal.js